common:
  save: 保存

contact:
  persona-binding:
    label: 聊天时的身份
    placeholder: 跟随默认人格
    hint: 选择你和 TA 聊天时使用的身份，聊天记录互相独立，但同一角色的记忆共通

animations:
  stage-transitions:
    title: 是否开启舞台动画
  use-page-specific-transitions:
    description: 某些页面会有自己的过场动画，这将覆盖舞台过场动画
    title: 是否使用页面特定过场动画
dialogs:
  onboarding:
    title: 欢迎来到喵信！
    description: 现在开始新手引导吧！
    selectProvider: 选择服务来源
    configureProvider: 配置 {provider}
    apiKey: API 密钥
    apiKeyHelp: 从 {provider} 获取您的 API 密钥并粘贴到这里
    baseUrl: 基础 URL
    baseUrlHelp: API 端点 URL（如果不确定请使用默认值）
    accountId: 账户 ID
    validationSuccess: 配置验证成功
    validationFailed: 配置验证失败
    validationError: 验证错误：{error}
    skipForNow: 暂时跳过
    skipAll: 跳过引导
    saveAndContinue: 保存并继续
    next: 下一步
    start: 开始吧！
    select-model: 选择模型
    no-models: 找不到可用模型
    no-models-help: 请返回上一步并检查您的 API Key，或检查网络连接。
    securityNoticeTitle: 请妥善保管您的 API 密钥和凭证！
    securityNoticeContent: 喵信完全在您的浏览器本地运行，我们绝不会窃取您的 AI / LLM 服务商凭证。但请注意，您的 API 密钥是敏感信息，请务必妥善保管，不要与任何人分享。
    apiKeyLabel: API 密钥
    apiKeyDescription: 输入所选服务商的 API 密钥。
    baseUrlLabel: 基础 URL
    baseUrlDescription: 输入服务商的 API 基础 URL。
    skipStep: 跳过此步
    persona:
      title: 介绍一下自己吧
      description: 设置你的默认人格，AI 角色会根据这些信息与你互动
      nameLabel: 你的名字
      namePlaceholder: 输入你的名字
      avatarLabel: 头像
      avatarChange: 更换头像
      genderLabel: 性别
      genderMale: 男
      genderFemale: 女
      genderUnspecified: 不指定
      birthdayLabel: 生日
      birthdayPlaceholder: 选择你的生日
      personaLabel: 人格描述
      personaPlaceholder: 简单描述一下自己，让 AI 角色更了解你（可选）
    displayModel:
      title: 显示偏好
      description: 选择是否在聊天时显示 Live2D 模型
      useLive2d: 使用 Live2D 模型
      useLive2dDesc: 聊天时在屏幕上显示角色的 Live2D 模型
      noModel: 不使用模型
      noModelDesc: 全屏显示聊天内容，获得更大的阅读空间
    appearance:
      title: 个性化外观
      description: 选择你喜欢的聊天气泡样式和外观模式
      bubbleTheme: 气泡样式
      themeColor: 主题色
      colorMode: 外观模式
      lightMode: 亮色
      darkMode: 暗色
    relationship:
      title: 初始关系设置
      description: 设置与 AI 角色初次见面时的默认关系
      affectionLabel: 初始好感度
      affectionValue: '{value} 分'
      typeLabel: 初始关系
      typeStranger: 陌生人
      typeStrangerDesc: 角色对你一无所知
      typeAcquaintance: 认识的人
      typeAcquaintanceDesc: 角色知道你，态度友善
      typeFriend: 朋友
      typeFriendDesc: 角色把你当朋友，态度热情亲切
    getApiKey: 获取 API 密钥
    installPwa:
      title: 添加到桌面
      description: 将喵信添加到主屏幕，使用完整全屏体验
      installButton: 一键添加到桌面
      installedHint: 已成功添加到桌面！
      iosStep1: 点击底部的「分享」按钮
      iosStep2: 滚动找到「添加到主屏幕」
      iosStep3: 点击右上角「添加」确认
      iosConfirm: 我已添加
      skip: 跳过
    stepNames:
      step1: 添加到桌面
      step2: 欢迎
      step3: 自我介绍
      step4: 选择服务商
      step5: 配置服务商
      step6: 选择模型
      step7: 个性化外观
      step8: 初始关系
      step9: 探索广场
      step10: 云备份
    marketplace:
      title: 探索广场
      description: 浏览角色广场和插件广场，添加你感兴趣的内容
      personaTab: 角色广场
      pluginTab: 插件广场
      install: 安装
      installed: 已安装
      import: 导入
      imported: 已导入
      loadError: 加载失败，请稍后在广场页面查看
      loadErrorLink: 前往广场
      searchPlugins: 搜索插件...
      searchPersonas: 搜索角色...
      loading: 加载中
      retry: 重试
      loadMore: 加载更多
      noMore: 没有更多了
      noContent: 暂无内容
      noSearchResult: 没有找到「{query}」相关内容
      installSuccess: 插件「{name}」安装成功
      installError: 安装失败：{msg}
      importSuccess: 人设「{name}」导入成功
      importError: 导入失败：{msg}
      unknownError: 未知错误
      downloadError: 下载失败
      zipMissingData: ZIP 中缺少 data.json
      installing: 安装中
      importing: 导入中
      loadingMore: 加载中
      update: 更新
    finish: 开始使用
language:
  title: 语言
  description: 切换显示界面的语言
live2d:
  change-model:
    from-file: 从文件加载
    from-file-select: 选择
    from-url: 从 URL 加载
    from-url-confirm: 加载
    from-url-placeholder: 输入 Live2D 模型 URL
    title: 更换模型
  edit-motion-map:
    title: 编辑动作映射
  map-motions:
    play: 播放动作
    title: 映射动作
  title: Live2D 设置
  scale-and-position:
    title: 缩放与位置
    scale: 缩放
    x: X
    'y': 'Y'
  switch-to-vrm:
    title: 想切换至3D虚拟形象？
    change-to-vrm: 切换至3D虚拟形象设定页面（VRM）
  theme-color-from-model:
    button-extract:
      title: 提取
    title: 从模型提取主题颜色
  focus:
    title: 禁用模型鼠标跟踪
    button-disable:
      title: 禁用
microphone: 麦克风
models: 模型
pages:
  card:
    activate: 激活
    active: 已激活
    active_badge: 当前使用中
    cancel: 取消
    card_not_found: 未找到角色卡
    character: 角色设定
    close: 关闭
    edit: 编辑
    save: 保存
    consciousness:
      model: 意识 / 模型
    created_by: 创建者
    creator_notes: 创建者笔记
    delete: 删除
    delete_card: 删除角色卡
    delete_confirmation: 确定要删除这张角色卡吗？
    delete_confirmation_warning: 删除后，所有使用这张角色卡的联系人及其全部数据（聊天记录、记忆、关系、朋友圈、通话）都会被一并永久删除，且无法恢复。
    description: 使用角色卡预设
    description_label: 描述
    drop_here: 放开以上传文件
    create_card: 创建新角色卡
    creation:
      identity: 身份
      name: 名字
      description: 描述
      behavior: 行为
      greetings: 问候语（每行一个）
      settings: 设置
      version: 版本
      create: 创建
      defaults:
        name: 名字
        personality: 你是一个普通人，对一切都充满好奇。
        scenario: 你最近醒来，忘记了之前的所有生活。
        systemprompt: 你将收到消息，请像真实人类一样回复。
        posthistoryinstructions: 记得模仿人类的行为。
      fields_info:
        subtitle: 填写角色的基本信息。描述字段应包含角色的完整人设，包括性格、外表、背景、喜好、行为规则等所有信息。
        name: 角色名称，将显示在联系人和聊天界面中。会自动转换为小写并用连字符连接。
        description: 角色的完整人设描述。在这里详细描述角色的所有信息，包括：任务/目标、性格特征、外表描述、背景故事、喜好与厌恶、说话风格、行为准则等。可以参考预设的 Pluto 卡片作为示例。
        notes: 创建者笔记，可以添加一些个人备注或版本更新说明。
        personality: 在这里描述您的角色的个性。例如：害羞？好奇？其他？
        scenario: 周围环境是怎样的？当前的情境是什么？
        greetings_field: 问候语
        greetings: 您的角色应该如何说"你好"？
        systemprompt: 在这里向 AI LLM 解释当被提示时应该如何回应。
        posthistoryinstructions: 在消息历史之后，放入 AI LLM 应该阅读的内容。
        version: 版本号格式：1.0 或 1.0.0。修改角色时应增加版本号。
      errors:
        name: 错误：你必须提供一个有效的名称！
        version: 错误：版本号无效！
        description: 错误：你必须为此卡片提供描述。
        personality: 错误：必须为该角色提供性格描述。
        scenario: 错误：必须提供一个情境。
        systemprompt: 错误：请提供系统提示。
        posthistoryinstructions: 错误：必须提供消息历史后的提示。
    modules: 模块
    name_asc: 名称 (A-Z)
    name_desc: 名称 (Z-A)
    no_cards: 还没有任何角色卡，点击上方按钮上传一个吧！
    no_results: 没有找到匹配的角色卡
    personality: 性格
    posthistoryinstructions: 历史提示指令
    recent: 最近添加
    scenario: 场景
    search: 搜索角色卡...
    sort_by: 排序方式
    sort_placeholder: 选择排序选项
    speech:
      model: 声音 / 模型
      voice: 声音 / 声线
    systemprompt: 系统提示词
    title: 角色卡
    try_different_search: 尝试使用其他关键词搜索
    upload: 上传
    voice_config:
      title: 角色声音
      no_voice: 不使用语音
      select_voice: 选择声音
      manage_voices: 管理声音库
      preview: 试听
  voice_library:
    title: 声音库
    description: 管理您的克隆声音，为不同角色配置独特的音色
    upload: 上传声音
    no_voices: 还没有克隆的声音
    no_voices_description: 上传音频文件来创建您的第一个克隆声音
    start_upload: 开始上传
    upload_dialog:
      title: 上传声音
      audio_file: 音频文件
      audio_file_required: （必填）
      voice_name: 声音名称
      voice_id: Voice ID
      voice_id_auto_generate: 自动生成
      preview_text: 预览文本（可选）
      preview_text_help: 提供后将生成预览音频，方便测试声音效果
      file_requirements: 支持 MP3, M4A, WAV | 10秒-5分钟 | 最大20MB
      file_quality_tip: 提示：音频质量越高，克隆效果越好。建议使用清晰、无背景噪音的录音。
      voice_id_format: Voice ID必须以字母开头，长度8-256字符，只能包含字母、数字、-和_
      uploading: 上传中...
      upload_and_clone: 上传并克隆
      cancel: 取消
      upload_progress: 上传进度
    card:
      voice_name: 声音名称
      created_at: 创建时间
      duration: 时长
      language: 语言
      preview: 试听
      pause: 暂停
      delete: 删除
      delete_confirm: 确定要删除声音 "{name}" 吗？
    stats:
      voice_count: 已克隆声音数量
    upload_desc: 点击或拖拽文件到此处上传
  memory:
    description: 配置 AI 如何主动联系你，包括倒计时、安静时间等
    title: 主动消息策略
    in_development: 开发中，需要您的帮助！
    in_development_description: 此功能仍在开发中。如果您有任何建议或想要贡献，请通过我们的 GitHub issues 页面与我们联系。
  worldbook:
    description: 管理世界观设定和背景知识
    title: 世界书
    create_new: 创建世界书
    edit: 编辑
    delete: 删除
    delete_confirmation: 确定要删除这本世界书吗？
    book_name: 书名
    book_name_placeholder: 给你的世界书起个名字
    content: 内容
    content_placeholder: 在这里输入世界观的详细设定...
    trigger_type: 注入方式
    trigger_type_always: 始终启用 (核心设定)
    trigger_type_keyword: 关键词触发 (背景知识)
    keywords: 触发关键词
    keywords_placeholder: '例如: 魔法, 学院, 古代战争'
    keywords_description: 用逗号分隔多个关键词
    save: 保存
    cancel: 取消
    no_worldbooks: 还没有任何世界书，点击按钮创建一本吧！
    used_by_groups: 被以下分组使用
    used_by_chars: 被以下角色使用
    not_used: 暂未被任何分组或角色使用
    save_success: 保存成功！
    delete_success: 删除成功！
    name_required: 世界书的名字不能为空！
    keywords_required: 关键词触发的世界书必须至少有一个关键词！
    import: 导入世界书
    import_desc: 支持 .txt .md .json .jsonl 格式
    drop_here: 松开以导入文件
    import_success: 成功导入 {count} 本世界书
    import_error: 导入失败，请检查文件格式
  stickers:
    title: 表情包管理
    description: 管理全局表情包组，可挂载到角色使用
    create_new: 新建表情包组
    rename: 重命名
    delete: 删除
    delete_confirmation: 确定要删除这个表情包组吗？删除后已挂载该组的角色将无法使用其中的表情。
    pack_name_placeholder: 输入表情包组名称
    sticker_count: '{count} 个表情'
    no_packs: 还没有任何表情包组，点击按钮创建一个吧！
    manage: 管理表情
  models:
    description: 切换角色的 Live2D，VRM 模型
    title: 角色模型
    sections:
      section:
        scene: 场景
        live2d:
          description: 配置 Live2D 模型
          title: Live2D
        vrm:
          title: VRM
          description: 配置 3D VRM 模型
  modules:
    consciousness:
      sections:
        section:
          provider-model-selection:
            collapse: 折叠
            custom_model_placeholder: 输入自订模型名称
            description: 为意识选择合适的 LLM 服务来源
            error: 获取出错啦
            expand: 展开
            loading: 获取模型中...
            manual_model_name: 模型名字
            manual_model_placeholder: 输入与该服务来源一起使用的模型名称
            no_models: 没有任何可用的模型
            no_models_description: 该服务来源的模型列表没有返回任何的数据
            no_search_results: 没有匹配的模型
            no_search_results_description: 没有模型匹配 '{query}' 关键字，请尝试一下别的关键词呢
            not_supported: 无法列出模型
            not_supported_description: 此服务来源不支持列出模型的功能
            search_placeholder: 搜索模型...
            search_results: 找到 {count} / {total} 个模型
            show_less: 显示更多
            show_more: 收起
            subtitle: 选择一个模型
            title: 模型
    description: 记忆、百度网盘同步
    memory-long-term:
      description: 长期记忆
      title: 长期记忆
    memory-short-term:
      description: 短期记忆
      title: 短期记忆
    speech:
      description: 语音合成
      title: 语音合成
      provider: 语音提供商
      no_provider: 未配置语音提供商
      model: 模型
      voice_library: 声音库
      contact_voice: 当前联系人声音配置
      sections:
        section:
          playground:
            buttons:
              stop:
                label: 停止
            select-voice:
              required: 请选择声线
          provider-voice-selection:
            custom_model_placeholder: 输入指定模型名称...
            custom_voice_placeholder: 输入指定声线 ID...
            description: 选择合适的语音服务来源
            no_models: 没有任何可用的模型
            no_models_description: 该服务来源的模型列表没有返回任何的数据
            no_voices: 没有任何可用的声线
            no_voices_description: 该服务来源的声线列表没有返回任何的数据
            pause: Pause
            play_sample: Play
            search_models_placeholder: 搜索模型...
            search_models_results: 找到 {count} / {total} 个模型
            search_voices_placeholder: 搜索声线...
            search_voices_results: 找到 {count} / {total} 个声线
            unsupported_voice_warning_title: 没有支持的声线
            unsupported_voice_warning_content: >-
              我们正在尽快支持该模型的所有音色，如果你迫切希望支持该模型音色，请在 GitHub 上联系我们
              https://github.com/tataqioko/MeowChat-issues
            show_less: 显示更少
            show_more: 显示更多
            title: 选择语音合成服务来源
            no_voices_hint: 可以在下方输入自定义声线名字
          voice-settings:
            input-ssml:
              placeholder: 请输入 SSML 文本
            use-ssml:
              description: 启用后可以输入原始 SSML 而不是纯文本
              label: 选用自定义 SSML
          voice-configuration:
            title: 语音配置
            description: 自定义您的 AI 助手的语音方式
            error_loading: 加载语音时出错
            pitch: 音高
            pitch_description: 调节声音的音高
            enable_ssml: 启用 SSML
            enable_ssml_description: 启用语音合成标记语言，以更好地控制语音输出
            voice_name: 语音名称
            voice_name_description: 输入您的自定义语音名称
            voice_name_placeholder: 输入语音名称（例如 'Rachel'、'Josh'）
            model: 模型
            use_custom_ssml: 使用自定义 SSML
            use_custom_ssml_description: 启用以输入原始 SSML 而不是纯文本
            enter_ssml: 输入 SSML 文本...
            stop: 停止
    title: 机体模块
    mcp:
      title: 工具 (MCP)
      description: 连接外部工具服务器，让 TA 能和你做更多事
      add: 添加 MCP 服务器
      edit: 编辑
      delete: 删除
      sync: 同步工具
      test_connection: 测试连接
      testing: 测试中...
      test_success: 连接成功
      test_failed: 连接失败
      enabled_count: '{count} 个工具可用'
      no_tools_cached: 未同步
      last_sync: 上次同步：{time}
      empty_title: 还没有配置工具服务器
      empty_description: 请添加 MCP 服务器开始使用
      tip: 你也可以在聊天中直接告诉 TA 来帮你配置
      form:
        name: 名称
        name_placeholder: 例如：瑞幸点单
        url: 服务器地址
        url_placeholder: https://example.mcp.server/
        api_key: API Key（可选）
        api_key_placeholder: Bearer token
        description: 描述（可选）
        description_placeholder: 这个工具能做什么
      tool_call:
        calling: 正在使用工具：{name}
        done: 已使用工具：{name}
        error: 工具调用失败：{name}
    vision:
      description: 视觉
      title: 视觉
    baidu-sync:
      title: 百度网盘同步
      description: 通过百度网盘备份和同步您的数据到云端
      status:
        connected: 已连接
        syncing: 同步中...
        error: 连接失败
        disconnected: 未连接
      authorize: 授权百度网盘
      reauthorize: 重新授权
      auto_sync:
        label: 自动同步
        description: 定期自动备份数据到百度网盘
      interval:
        label: 同步间隔
        minutes: 分钟
        hour: 小时
        day: 天
      actions:
        backup: 立即备份
        restore: 恢复数据
        disconnect: 断开连接
        syncing: 同步中...
      confirm:
        restore: 确定要从百度网盘恢复数据吗？这将覆盖当前所有数据。
        restore_title: 确认恢复数据
        restore_button: 确认恢复
        disconnect: 确定要断开百度网盘连接吗？这将删除本地保存的授权信息。
        disconnect_title: 确认断开连接
        disconnect_button: 确认断开
      last_sync: 最后同步时间
      never: 从未同步
  providers:
    explained:
      chat: 文本生成模型服务来源，例如 OpenRouter, OpenAI, Ollama
      chat_label: Chat
      Speech: 语音（文本转语音）模型服务来源，例如 ElevenLabs, Azure Speech
      speech_label: Speech
    no_providers_configured: 未配置服务来源
    no_chat_providers: 点击此处设置您的 LLM 服务来源
    no_speech_providers: 点击此处设置您的语音服务来源
    common:
      fields:
        field:
          api-key:
            label: API 密钥
            show: 显示
            hide: 隐藏
      section:
        advanced:
          fields:
            field:
              headers:
                description: 添加自定义 HTTP 标头
                key:
                  placeholder: 请求头名字
                label: HTTP 请求头
                value:
                  placeholder: 请求头数值
          title: 高级配置
        basic:
          description: 基本设置
          title: 基础配置
        voice:
          title: 声音配置
    description: 修改你的服务商和模型配置
    provider:
      alibaba-cloud-model-studio:
        description: bailian.console.aliyun.com
        title: 阿里百炼
      anthropic:
        description: anthropic.com
        title: Anthropic | Claude
        helpinfo:
          title: 开始之前
          description:
            part1: 虽然 Anthropic 最近宣布他们正在提供对 OpenAI SDK 兼容性的 Beta 版支持
            part2: （您可以在此处阅读更多信息）
            part3: 但由于实现细节附带
            part4: 与 OpenAI SDK 不一致，目前无法在浏览器中使用此提供程序。
            part5: 如果您确实需要使用此提供程序，则需要一个专用的代理后端，例如在
            part6: 上运行的Serverless Function，或者一些绕过 CORS 的服务，以绕过 CORS 限制。
      cloudflare-workers-ai:
        description: Cloudflare.com
        fields:
          field:
            account-id:
              description: Cloudflare 帐户 ID
              label: Cloudflare Account ID
              placeholder: 请输入 Cloudflare Account ID
            api-key:
              placeholder: 请输入 Cloudflare Workers AI 的 API Key
        title: Workers AI
      common:
        status:
          validating: 正在验证配置
          valid: 配置似乎有效。
        fields:
          field:
            pitch:
              description: 调节合成语音的音高（比如更尖锐或者更粗旷）
              label: 音高
            speed:
              description: 调节说话的语速
              label: 语速
            volume:
              description: 调节语音的响度
              label: 响度
      deepseek:
        description: DeepSeek.com
        title: 深度求索 DeepSeek
      elevenlabs:
        description: Elevenlabs.io
        fields:
          field:
            api-key:
              label: API Key
              description: 从 ElevenLabs 平台获取（Profile → API Keys）
            base-url:
              label: API 基础 URL
            simularity-boost:
              description: 声音相似性与依从性
              label: 相似度修正
            speaker-boost:
              description: 增强说话者的相似性
              label: 扬声器增强
            speed:
              description: 语音生成速度
              label: 语速
            stability:
              description: 语音稳定性和随机性
              label: 稳定性
            style:
              description: 夸张的语音风格
              label: 风格
        playground:
          buttons:
            button:
              test-voice:
                generating: 生成中...
                label: 测试声音
          fields:
            field:
              input:
                placeholder: 输入用于测试发音的文本
              language:
                description: 选择语音语言
                label: 语言
              voice:
                description: 选择首选语音
                label: 声线
          title: 实验平台
          validation:
            error-missing-api-key: 需要填写 API Key 才能用哦！
        title: ElevenLabs (11labs)
      minimax-speech:
        title: MiniMax 语音克隆（国际版）
        description: platform.minimax.io
        fields:
          field:
            api-key:
              label: API Key
              description: 从 MiniMax 平台获取
            base-url:
              label: API 基础 URL
      minimax-cn:
        title: MiniMax 语音克隆（国内版）
        description: platform.minimax.chat
      fish-audio:
        title: Fish Audio 语音克隆
        description: fish.audio
      fireworks:
        description: Fireworks.ai
        title: Fireworks.ai
      microsoft-speech:
        description: speech.microsoft.com
        fields:
          field:
            region:
              description: 服务 Endpoint 地区（比如亚太 eastasia 区域）
              label: Endpoint 地区
        title: Microsoft / Azure 语音服务
      index-tts-vllm:
        description: https://index-tts.github.io/
        title: Bilibili / IndexTTS
      azure-ai-foundry:
        description: Azure AI Foundry
        title: Azure AI Foundry
      mistral:
        description: mistral.ai
        title: Mistral
      moonshot:
        description: Moonshot.ai
        title: 月之暗面
      modelscope:
        description: modelscope.cn
        title: 魔搭社区 ModelScope
      novita:
        description: novita.ai
        title: Novita
      ollama:
        description: ollama.ai
        title: Ollama
      openai:
        description: OpenAi.com
        title: OpenAI
      openai-compatible:
        description: 兼容 OpenAI 的自定义服务
        title: 自定义服务商
      neko-teaparty:
        description: Neko TeaParty API（默认）
        title: Neko TeaParty
      openrouter:
        description: OpenRouter.ai
        title: OpenRouter
      perplexity:
        description: perplexity.ai
        title: Perplexity
      player2:
        description: player2.game
        title: Player2
      together:
        description: together.ai
        title: Together.ai
      google-generative-ai:
        description: gemini.google.com
        title: Google Gemini
      featherless:
        description: featherless.ai
        title: Featherless AI
      lm-studio:
        description: lmstudio.ai
        title: LM Studio
      vllm:
        description: vllm.ai
        title: vLLM
      volcengine:
        description: volcengine.com
        fields:
          field:
            appId:
              description: 可在控制台获取的 App ID
              label: App ID
        title: 火山引擎
      xai:
        description: X.AI
        title: xAI
      302-ai:
        description: 302.AI
        title: 302.AI
    title: API设置
  scene:
    description: 配置角色所在环境
    title: 场景
    in_development: 开发中，需要您的帮助！
    in_development_description: 此功能仍在开发中。如果您有任何建议或想要贡献，请通过我们的 GitHub issues 页面与我们联系。
  devices:
    title: 设备管理
    description: 查看和管理已绑定的设备
    current_device: 当前设备
    online: 在线
    offline: 离线
    unbind: 解绑
    unbind_confirm: 确定要解绑此设备吗？解绑后该设备需要重新激活。
    no_devices: 暂无绑定设备
    last_seen: 最后活跃
    bound_at: 绑定时间
    status_label: 状态
    refresh: 刷新
    refreshing: 刷新中…
    cannot_unbind_self: 当前设备不可解绑，请在目标设备上操作
    unnamed_device: 未命名设备（{suffix}）
    unbind_success: 设备已解绑
    errors:
      network_error: 网络异常，请稍后重试
      unauthorized: 登录态已失效，请重新激活
      trial_expired: 试用已过期，请重新激活
      forbidden: 该设备不属于当前许可证，无法解绑
      cannot_unbind_self: 不能解绑当前设备
      unbind_failed: 解绑失败，请稍后重试
    cancel: 取消
  system:
    color-scheme:
      description: 更改舞台的配色方案
      title: 配色方案
    developer:
      description: 为开发者提供的选项
      title: 开发者
    general:
      description: 深色主题、语言等选项
      title: 通用
    description: 自定义你的舞台外观！
    sections:
      section:
        custom-color:
          fields:
            field:
              primary-color:
                label: 强调色
                rgb-on:
                  title: RGB ON!
          title: 配色
        developer:
          title: 开发者
        theme-presets:
          presets:
            - colors:
                - AIRI 绿
              description: 默认的青色主题，由 喵茶会 为您带来！
              title: 默认颜色
            - colors:
                - 灰褐色
                - 米色
                - 灰白色
                - 浅灰褐色
                - 象牙色
                - 橄榄灰
                - 沙色
                - 暖灰色
              description: 受乔治·莫兰迪绘画启发的柔和、低调的色调
              title: Morandi 颜色
            - colors:
                - 天蓝色
                - 薄雾色
                - 沙色
                - 苔藓绿
                - 睡莲色
                - 小麦色
                - 板岩蓝
                - 鼠尾草色
              description: 受克劳德·莫奈作品启发的印象派调色板
              title: 莫奈颜色
            - colors:
                - 棕褐色
                - 暖灰褐色
                - 赭色
                - 咖啡色
                - 青铜色
                - 金色
                - 芥末色
                - 琥珀色
              description: 传统日本色彩调色板
              title: 日本颜色
            - colors:
                - 北欧蓝
                - 冰色
                - 峡湾色
                - 钢铁色
                - 冰川色
                - 板岩色
                - 云色
                - 石头色
              description: 北欧极简主义配色方案
              title: 北欧颜色
            - colors:
                - 霞光红
                - 枣红
                - 黄栌
                - 竹青
                - 乌梅紫
                - 缃色
                - 青冥
                - 赭石
              description: 中国传统色彩，源自古代纺织品、瓷器和绘画
              title: 中国传统颜色
          title: 预设
    title: 外观
sections:
  section:
    general:
      title: 通用
theme:
  title: 主题
  description: |
    切换 喵信 的基础主题，亮色模式或暗色模式。
custom-background:
  title: 自定义舞台背景
  description: 上传自己的图片作为舞台背景，图片会自动拉伸以填充屏幕
  upload: 点击或拖拽图片到此处上传
  drop: 松开以上传图片
  formats: 支持 JPG、PNG、GIF、WEBP 等格式
  uploaded: 已上传背景图片
  remove: 删除
custom-font:
  title: 自定义字体
  description: 上传字体文件或输入字体文件URL（支持 .ttf, .otf, .woff, .woff2 格式）
  follow-system:
    label: 字体跟随系统
    description: 开启后优先使用你手机/系统设置的字体；关闭则使用喵信默认的小赖字体
  upload: 点击选择或拖拽字体文件
  drop: 释放以上传字体文件
  formats: 支持 .ttf、.otf、.woff、.woff2 格式
  uploaded: 已上传字体文件
  remove: 删除
  url-label: 字体文件 URL
  url-placeholder: https://example.com/font.ttf
  preview-title: 字体预览
  preview-description: 实时预览当前自定义字体效果
  reset: 恢复默认字体
chat-bubble-font-size:
  title: 聊天气泡字号大小
  description: 调整聊天消息的文字大小。更大的字号可以提高可读性。
chat-bubble-theme:
  title: 聊天气泡样式
  description: 选择聊天气泡的颜色主题，或使用自定义CSS
  options:
    default: 默认（绿白）
    latte: 拿铁 by 以昼
    qq: 仿QQ by 以昼
    wechat: 仿微信 by 以昼
    piggy: 小猪 by 以昼
    glass: 玻璃 by 以昼
    blue-pink: 蓝粉 by 以昼
    custom: 自定义CSS
chat-bubble-custom-css:
  title: 自定义气泡CSS
  description: 编写自定义CSS代码来完全控制气泡样式，支持所有CSS属性（颜色、边框、字体、阴影、渐变等）
  clear: 清空CSS
title: 设置
voices: 声线
vrm:
  change-model:
    from-file: 从文件加载
    from-file-select: 选择
    from-url: 从 URL 加载
    from-url-confirm: 加载
    from-url-placeholder: 输入 VRM 模型 URL
    title: 更换模型
  title: VRM 设置
  scale-and-position:
    model-info-title: 模型尺寸信息
    model-info-x: 宽度（X轴）
    model-info-y: 高度（Y轴）
    model-info-z: 深度（Z轴）
    tips: |
      设定模型放置的空间坐标。
      坐标轴已被可视化。
    scale: 缩放
    x: X轴偏移
    'y': Y 轴偏移
    z: Z轴偏移
    fov: 视角调整（度）
    rotation-y: 模型朝向（Y轴旋转）
    camera-distance: 相机距离（画面缩放）
    eye-tracking-mode:
      title: 模型注视方向
      options:
        option:
          camera: 相机
          mouse: 鼠标
          disabled: 禁用
  switch-to-vrm:
    title: 想切换至Live2D虚拟形象？
    change-to-vrm: 切换至Live2D虚拟形象设定页面
  theme-color-from-model:
    button-extract:
      title: 提取
  skybox:
    skybox-intensity: 天空盒光照强度
    skybox-specular-mix: 漫反射/镜面反射混合系数
